import dateFormatterWithDots from "web/utils/data/parser/dateAndTime/dateFormatterWithDots";

import { BENEFIT_PRODUCT_TYPES } from "web/constants/benefits";

import { MBProductType } from "web/types/Product";

export const isSubscriptionDisabled = (
  productType: MBProductType,
  isWindowOpen: boolean,
  isUmsWindowOpen: boolean
) => {
  switch (productType) {
    case BENEFIT_PRODUCT_TYPES.GROUP_1:
      return !isWindowOpen;
    case BENEFIT_PRODUCT_TYPES.GROUP_2:
      return !isUmsWindowOpen;
    default:
      return false;
  }
};

export const getProductTypeWindowDate = (
  productType: MBProductType,
  chooseSubscriptionsTo: string,
  startSubscriptionsFrom: string,
  chooseUmsSubscriptionsTo: string,
  startUmsSubscriptionsFrom: string
) => {
  const finalDates = {
    fullDateToDate: dateFormatterWithDots(chooseSubscriptionsTo),
    fullDateFromDate: dateFormatterWithDots(startSubscriptionsFrom),
  };
  const finalDatesUms = {
    fullDateToDate: dateFormatterWithDots(chooseUmsSubscriptionsTo),
    fullDateFromDate: dateFormatterWithDots(startUmsSubscriptionsFrom),
  };

  switch (productType) {
    case BENEFIT_PRODUCT_TYPES.GROUP_1:
      return finalDates;
    case BENEFIT_PRODUCT_TYPES.GROUP_2:
      return finalDatesUms;
    default:
      return null;
  }
};
